AdminControllers.controller('AdminUsersController', function($scope, $http) {

  $scope.user = {
    name: '',
    email: '',
    password: '',
    company: '',
    newPassword: '',
    tenantId: ''
  };

  $scope.result = null;
  $scope.fetchedUser = null;

  $scope.accessAllowed = false;
  $scope.loadingUser = true;

  $http.get('/api/authenticated')
  .then(function(response) {
    const email = response.data.user?.email || '';
    $scope.accessAllowed = email.endsWith('@ossianconsulting.com');
    $scope.loadingUser = false;
    $scope.$applyAsync();
  })
  .catch(function(error) {
    $scope.loadingUser = false;
    $scope.accessAllowed = false;
    $scope.$applyAsync();
  });

  $scope.createUser = function() {
    $http.post('/api/admin/users', $scope.user)
    .then(function(response) {
      $scope.result = { message: response.data.message, type: 'success' };
      $scope.fetchedUser = null;
    })
    .catch(function(err) {
      $scope.result = { message: err.data.message || 'Error creating user', type: 'danger' };
      $scope.fetchedUser = null;
    });
  };

  $scope.deleteUser = function() {
    const email = encodeURIComponent($scope.user.email);
    $http.delete('/api/admin/users/' + email)
    .then(function(response) {
      $scope.result = { message: response.data.message, type: 'success' };
      $scope.fetchedUser = null;
    })
    .catch(function(err) {
      $scope.result = { message: err.data.message || 'Error deleting user', type: 'danger' };
      $scope.fetchedUser = null;
    });
  };

  $scope.changePassword = function() {
    const email = encodeURIComponent($scope.user.email);
    $http.put('/api/admin/users/' + email + '/password', { password: $scope.user.newPassword })
    .then(function(response) {
      $scope.result = { message: response.data.message, type: 'success' };
      $scope.user.newPassword = '';
      $scope.fetchedUser = null;
    })
    .catch(function(err) {
      $scope.result = { message: err.data.message || 'Error changing password', type: 'danger' };
      $scope.fetchedUser = null;
    });
  };

  $scope.fetchUser = function() {
    const email = encodeURIComponent($scope.user.email);
    $http.get('/api/admin/users/' + email)
    .then(function(response) {
      $scope.fetchedUser = response.data;
      $scope.result = { message: 'User found: ' + response.data.name, type: 'info' };
    })
    .catch(function(err) {
      $scope.fetchedUser = null;
      $scope.result = { message: err.data.message || 'User not found', type: 'warning' };
    });
  };
});
